module.exports = __webpack_public_path__ + "static/img/drive-m@2x.c39f0669.png";